function Footer() {
  return (

    <footer className="footer">
      <p className="footer__paragraph">Timur Gainutdinov, web-developer | october 2022, learning continues</p>
    </footer>

  )
}

export default Footer;
